import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, delay, tap, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { AdministrationService } from "../../service/administration.service";
import { LegalEntitiesActions } from "./legal-entities.reducer";
import { AdministrationActions } from "../administration/administration.actions";
import { MessageService } from 'primeng/api';
import { LegalEntitiesService } from "../../service/legal-entities.service";
import { DownloadLegalEntitiesQueryResponse, GetLegalEntitiesQuery } from "../../../../graphql/generated";

export type GraphResponse<T> = {
  data: {
    [id: string]: T[];
  };
};

@Injectable()
export class LegalEntitiesEffects {
  // loadLegalEntitiess$ = createEffect(
  //   (leService: AdministrationService = inject(AdministrationService)) => {
  //     return this.actions$.pipe(
  //       ofType(LegalEntitiesActions.loadLegalEntities),
  //       switchMap(({ parameters, filtering, fields, manageScope }) =>
  //         leService.getLegalEntities(parameters, manageScope).pipe(
  //           map((legalEntities) =>
  //             LegalEntitiesActions.loadLegalEntitiesSuccess({
  //               legalEntities: legalEntities.data.legalEntitiesByQueryComplex,
  //               filtering,
  //               fields
  //             })
  //           ),
  //           catchError((error) =>
  //             of(LegalEntitiesActions.loadLegalEntitiesFailure({ error }))
  //           )
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  // loadLegalEntitiesNames$ = createEffect(
  //   (leService: AdministrationService = inject(AdministrationService)) => {
  //     return this.actions$.pipe(
  //       ofType(AdministrationActions.loadFiltersNames, LegalEntitiesActions.loadLegalEntitiesNames),
  //       switchMap(() =>
  //         leService.getLegalEntitiesFiltersNames().pipe(
  //           map((legalEntities) =>
  //             LegalEntitiesActions.loadLegalEntitiesNamesSuccess({
  //               legalEntities: legalEntities.data,
  //             })
  //           ),
  //           catchError((error) =>
  //             of(LegalEntitiesActions.loadLegalEntitiesNamesFailure({ error }))
  //           )
  //         )
  //       )
  //     );
  //   },
  //   { functional: true }
  // );

  loadLegalEntitiesNames$ = createEffect(
    (leService: LegalEntitiesService = inject(LegalEntitiesService)) => {
      return this.actions$.pipe(
        ofType(AdministrationActions.loadFiltersNames, LegalEntitiesActions.loadLegalEntitiesNames),
        switchMap((action) => {
          const parameters = { page: 0, rows: 1000000, filters: {}, order: { sortDirection: 'ASC', sortField: null }, search: null }
          const campaign = 'campaign' in action ? action.campaign : undefined
          return leService.loadLegalEntitiesNames(parameters, undefined, campaign).pipe(
            map((legalEntities) =>
              LegalEntitiesActions.loadLegalEntitiesNamesSuccess({
                legalEntities: legalEntities?.data
              })
            ),
            catchError((error) =>
              of(LegalEntitiesActions.loadLegalEntitiesNamesFailure({ error }))
            )

          )
        }
        )
      );
    },
    { functional: true }
  );


  loadLegalEntities$ = createEffect(
    (ls: LegalEntitiesService = inject(LegalEntitiesService)) => {
      return this.actions$.pipe(

        ofType(LegalEntitiesActions.loadLegalEntities),
        mergeMap(({ parameters, fields, filtering, manageScope, campaign }) =>
          ls.loadLegalEntities(parameters, manageScope, campaign).pipe(
            map((legalEntities) => {
              return LegalEntitiesActions.loadLegalEntitiesSuccess({
                legalEntities: legalEntities as GetLegalEntitiesQuery['legalEntitiesByQueryComplex'],
                fields,
                filtering
              });
            }),
            catchError((error) => of(LegalEntitiesActions.loadLegalEntitiesFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  exportLegalEntities$ = createEffect(
    (ls: LegalEntitiesService = inject(LegalEntitiesService), as: AdministrationService = inject(AdministrationService)) => {
      return this.actions$.pipe(
        ofType(LegalEntitiesActions.exportLegalEntities),
        mergeMap(({ parameters, timeZone }) =>
          ls.exportLegalEntities(parameters, timeZone).pipe(
            map((legals) => {
              as.downloadFile(
                legals!.data![0]!.content,
                legals!.data![0]!.filename!
              );
              return LegalEntitiesActions.exportLegalEntitiesSuccess({
                legalEntitiess: legals?.data as DownloadLegalEntitiesQueryResponse
              });
            }),
            catchError((error) => of(LegalEntitiesActions.exportLegalEntitiesFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  syncronize$ = createEffect(
    (leService: AdministrationService = inject(AdministrationService), messageService: MessageService = inject(MessageService)) => {
      return this.actions$.pipe(
        ofType(LegalEntitiesActions.syncronizeLegalEntities),
        tap(() => {
          messageService.add({ summary: 'Synchronization in progress', detail: '...', severity: 'info', life: 1500 })
        }),
        mergeMap(() =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          leService.syncronizeLegalEntities().pipe(
            delay(3000),
            map(() => {
              //lancio mS per lanciare il toast
              messageService.add({ summary: 'Synchronization completed', detail: 'the data is up to date.', severity: 'success' })
              return LegalEntitiesActions.loadLegalEntities(
                {
                  parameters: {
                    filters: [],
                    rows: 150,
                    page: 0,
                    search: "",
                    order: { sortDirection: "ASC", sortField: null }
                  },
                  firstLoading: true
                }
              );
            }),
            catchError(() => {
              messageService.add({ summary: 'Synchronization completed', severity: 'success' })
              return of(LegalEntitiesActions.loadLegalEntities(
                {
                  parameters: {
                    filters: [],
                    rows: 150,
                    page: 0,
                    search: "",
                    order: { sortDirection: "ASC", sortField: null }
                  },
                  firstLoading: true
                }
              )
              )
            }
            )
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
